module.exports = __webpack_public_path__ + "625e94024a73c1f5edd1d9d79adc1b75.png";